import comp from "./MeasureAssessingWrapper";
export default comp;
